import { VRCAudioMetadata } from '@pwp-common';

import { RowCell } from '../../../../../common/p-table/row-cell';

import { AudioFilesEditorRow } from './interfaces';

//////////////////////////////////////////////////////////////////////////////////////////
// Audio files editor row
//////////////////////////////////////////////////////////////////////////////////////////

export const createAudioFilesEditorRow = (vrcAudioMetadata: VRCAudioMetadata): AudioFilesEditorRow => ({
  id: vrcAudioMetadata.getId(),
  displayName: createValueCell(vrcAudioMetadata.getDisplayName()),
  description: createValueCell(vrcAudioMetadata.getDescription()),
  vrcAudioMetadata,
});

//////////////////////////////////////////////////////////////////////////////////////////
// Value cell
//////////////////////////////////////////////////////////////////////////////////////////

const createValueCell = (value: string): RowCell<string> =>
  new RowCell<string>({
    translationScope: 'audio-files-table-editor',
    translationKey: 'cellValue',
    translationObj: { value },
    sortValue: value,
  });
